import { booleanAttribute, Component, input, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Icon } from "@malirang/front-share";

@Component({
    selector: "app-chat-tooltip",
    templateUrl: "./chat-tooltip.component.html",
    styleUrls: ["./chat-tooltip.component.css"],
    imports: [CommonModule, Icon],
})
export class ChatTooltipComponent {
    close = output<void>();

    disableClose = input<boolean, string>(false, {
        transform: booleanAttribute,
    });
}
